import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Api from './api';
import * as Actions from './actions';

export const fetchEmployeeObservable = employeeId =>
    Api.fetchEmployee(employeeId).map(newEmployee => Actions.fetchEmployeeSuccess.action(newEmployee));

const fetchEmployee = action$ =>
    action$
        .ofType(Actions.fetchEmployee.type)
        .mergeMap(({payload}) =>
            fetchEmployeeObservable(payload.employeeId).catch(e =>
                Observable.of(Actions.fetchEmployeeFailed.action(e)),
            ),
        );

export const fetchAllEmployeesObservable = institutionId =>
    Api.fetchAllEmployees(institutionId).map(employees =>
        Actions.fetchAllEmployeesSuccess.action({employees, institutionId}),
    );

const fetchAllEmployees = action$ =>
    action$
        .ofType(Actions.fetchAllEmployees.type)
        .mergeMap(({payload}) =>
            fetchAllEmployeesObservable(payload.institutionId).catch(e =>
                Observable.of(Actions.fetchAllEmployeesFailed.action(e)),
            ),
        );

export const createEmployeeObservable = (institutionId, name, email, groupId, phone, status) =>
    Api.createEmployee(institutionId, name, email, groupId, phone, status).map(employee =>
        Actions.createEmployeeSuccess.action({employee}),
    );

const createEmployee = action$ =>
    action$
        .ofType(Actions.createEmployee.type)
        .mergeMap(({payload}) =>
            createEmployeeObservable(payload.institutionId, payload.name, payload.email, payload.groupId).flatMap(
                createEmployeeSuccessActionObservable => [createEmployeeSuccessActionObservable],
            ),
        )
        .catch(e => Observable.of(Actions.createEmployeeFailed.action(e)));

const updateGroup = action$ =>
    action$.ofType(Actions.updateGroup.type).mergeMap(({payload}) =>
        Api.updateGroup(payload.employeeId, payload.groupId)
            .flatMap(employee => [Actions.updateGroupSuccess.action({employee})])
            .catch(e => Observable.of(Actions.updateGroupFailed.action({employeeId: payload.employeeId, error: e}))),
    );

const updateKeyChildren = action$ =>
    action$.ofType(Actions.updateKeyChildren.type).mergeMap(({payload}) =>
        Api.updateKeyChildren(payload.employeeId, payload.keyChildren)
            .flatMap(response => [Actions.updateKeyChildrenSuccess.action(payload.employeeId, response.relations)])
            .catch(e =>
                Observable.of(Actions.updateKeyChildrenFailed.action({employeeId: payload.employeeId, error: e})),
            ),
    );

export default combineEpics(fetchEmployee, fetchAllEmployees, updateGroup, createEmployee, updateKeyChildren);
